import { REPORTS_MEDICINE_WISE_STOCK_REQUEST } from "../../framework/tab/tabUtilsConstants";
import moment from "moment";
import { dateFilterComparator } from "../../utils/utils";
export const columnDefs = [
  {
    headerName: "Stock Request ID",
    field: "stockRequestId",
    width: 150,
  },
  {
    headerName: "Stock Transfer ID",
    field: "stockTransferId",
    width: 150,
  },
  {
    headerName: "From Branch ID",
    field: "fromBranchId",
    width: 150,
  },
  {
    headerName: "To Branch ID",
    field: "toBranchId",
    width: 150,
  },
  {
    headerName: "Product ID",
    field: "productId",
    width: 150,
  },
  {
    headerName: "Product Name",
    field: "productName",
    width: 200,
  },
  {
    headerName: "Requested Quantity",
    field: "requestedQuantity",
    width: 180,
  },
  {
    headerName: "Transferred Quantity",
    field: "transferedQuantity",
    width: 180,
  },
  {
    headerName: "Stock Request Date and Time",
    field: "stockRequestDateTime",
    width: 250,
  },
  {
    headerName: "Stock Transfer Date and Time",
    field: "stockTransferDateTime",
    width: 250,
  },
  {
    headerName: "Request Remark",
    field: "remarks",
    width: 150,
  },
  {
    headerName: "Transfer Remark",
    field: "transferRemarks",
    width: 150,
  },
  {
    headerName: "Status",
    field: "status",
    width: 150,
  },
  {
    headerName: "Request Reason",
    field: "requestReason",
    width: 150,
  },
  {
    headerName: "Request Raised By",
    field: "requestedBy",
    width: 180,
  },
];
export const columnDefsFunctions = {
  stockRequestDateTime: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
  stockTransferDateTime: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
  status: {
    cellStyle: (params) => {
      return {
        borderRight: "1px solid #a0a0a0",
        ...(params.value === "ACCEPTED" && { color: "green" }),
        ...(params.value === "REJECTED" && { color: "red" }),
        ...(params.value !== "ACCEPTED" &&
          params.value !== "REJECTED" && { color: "black" }),
      };
    },
  },
};

export const initial_state_medicine_wise_stock_request_report = {
  type: REPORTS_MEDICINE_WISE_STOCK_REQUEST,
  label: "Medicine Wise Stock Request Report",
  allowMultipleTabs: false,
};
